import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=127bda26&"
import script from "./Coupon.vue?vue&type=script&lang=js&"
export * from "./Coupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('127bda26')) {
      api.createRecord('127bda26', component.options)
    } else {
      api.reload('127bda26', component.options)
    }
    module.hot.accept("./Coupon.vue?vue&type=template&id=127bda26&", function () {
      api.rerender('127bda26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/basket/Coupon.vue"
export default component.exports